(function ($) {


    const tabletMediaQueryList = window.matchMedia("(max-width: 768px)");
    let isTabletBreakpoint = tabletMediaQueryList.matches;

    tabletMediaQueryList.addEventListener?.("change", checkIfTabletBreakpoint) || tabletMediaQueryList.addListener(checkIfTabletBreakpoint);

    tabletMediaQueryList.addEventListener?.("change", checkIfTabletBreakpoint) || tabletMediaQueryList.addListener(checkIfTabletBreakpoint);


    function placeCaseStudiesSeeMoreButton() {
        const $singleCaseStudyReadMoreButton = $('.cs-related .content-cards__btn');

        if(isTabletBreakpoint) {
            $singleCaseStudyReadMoreButton.closest('.container').append($singleCaseStudyReadMoreButton);
            $singleCaseStudyReadMoreButton.attr('data-moved-with-js', 1);
        }

       else {
            $singleCaseStudyReadMoreButton.closest('.cs-related').find('.content-cards__header').append($singleCaseStudyReadMoreButton);
            $singleCaseStudyReadMoreButton.attr('data-moved-with-js', 1);
        }
    }


    function checkIfTabletBreakpoint() {
        isTabletBreakpoint = tabletMediaQueryList.matches;
        placeCaseStudiesSeeMoreButton();
    }


    $(document).on('ready', function () {

        checkIfTabletBreakpoint();

    });


})(jQuery);